import React, { useEffect, useState } from "react"
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"

// Formik Validation
import { useFormik } from "formik"
import API_SERVICE from "shared/services/api-services"
import { getName, notification } from "shared/utility/Utility"
import * as Yup from "yup"
//redux
import withRouter from "components/Common/withRouter"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

// actions

const UserProfile = () => {
  //meta title
  document.title = "Profile | Inventya - React Admin & Dashboard Template"

  const dispatch = useDispatch()
  const [dataUser, setData] = useState([])

  const ProfileProperties = createSelector(
    state => state.Profile,
    profile => ({
      error: profile.error,
      success: profile.success,
    })
  )
  const { error, success } = useSelector(ProfileProperties)
  const getData = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchSelf()
      setData(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      previousPassword: "",
      currentPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      previousPassword: Yup.string().required("Please Enter Previous Password"),
      currentPassword: Yup.string().required("Please Enter New Password"),
      confirmPassword: Yup.string().required("Please Confirm Your Password"),
    }),

    onSubmit: async values => {
      try {
        if (values.currentPassword != values.confirmPassword) {
          notification("error", "Entered passwords do not match")
          return
        }
        const params = {
          currentPassword: values["currentPassword"],
          previousPassword: values["previousPassword"],
        }
        const { data } = await API_SERVICE.updatePassword(dataUser.id, params)
        validation.resetForm()
        notification("success", "Password Updated")
      } catch (error) {
        notification("error", error.response.statusText)
      }
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Inventya" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <div
                        className="avatar-md rounded-circle img-thumbnail"
                        style={{
                          backgroundColor: "#E4661D",
                          border: "3px solid #FFEADE",
                          color: "#FFFFFF",
                          fontSize: "20px",
                          fontWeight: "500",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {getName(dataUser?.name)}
                      </div>
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{dataUser?.name}</h5>
                        <p className="mb-1">{dataUser?.email}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4" style={{ color: "#A6B0CF" }}>
            UPDATE PASSWORD
          </h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <div className="mb-3 w-50">
                  <Label className="form-label">Current Password</Label>
                  <Input
                    name="previousPassword"
                    label="Password"
                    type="password"
                    placeholder="Enter your current password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.previousPassword || ""}
                    invalid={
                      validation.touched.previousPassword &&
                      validation.errors.previousPassword
                        ? true
                        : false
                    }
                  />
                  {validation.touched.previousPassword &&
                  validation.errors.previousPassword ? (
                    <FormFeedback type="invalid">
                      {validation.errors.previousPassword}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3 w-50">
                  <Label className="form-label">New Password</Label>
                  <Input
                    name="currentPassword"
                    label="Password"
                    type="password"
                    placeholder="Enter new password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.currentPassword || ""}
                    invalid={
                      validation.touched.currentPassword &&
                      validation.errors.currentPassword
                        ? true
                        : false
                    }
                  />
                  {validation.touched.currentPassword &&
                  validation.errors.currentPassword ? (
                    <FormFeedback type="invalid">
                      {validation.errors.currentPassword}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3 w-50">
                  <Label className="form-label">Confirm New Password</Label>
                  <Input
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    placeholder="Re-enter new password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.confirmPassword || ""}
                    invalid={
                      validation.touched.confirmPassword &&
                      validation.errors.confirmPassword
                        ? true
                        : false
                    }
                  />
                  {validation.touched.projects && validation.errors.projects ? (
                    <FormFeedback type="invalid">
                      {validation.errors.confirmPassword}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mt-4">
                  <Button type="submit" className="theme-btn">
                    Update
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
